export const STATE = {
  Initial: 'initial',
  Pending: 'pending',
  Success: 'success',
  Error: 'error',
} as const;
